<app-header
  class="layout-header"
  [menuToggleEnabled]="minMenuSize() === 0 && appNavigation().length > 0"
  (menuToggle)="menuOpened.set(!menuOpened())"
  [appTitle]="appTitle()"
/>

<dx-drawer
  class="layout-body"
  position="before"
  [closeOnOutsideClick]="menuMode() === 'overlap'"
  [openedStateMode]="menuMode()"
  [revealMode]="menuRevealMode()"
  [minSize]="minMenuSize()"
  [shading]="shaderEnabled()"
  [(opened)]="menuOpened"
>
  <app-side-navigation-menu
    [compactMode]="!menuOpened()"
    [selectedItem]="selectedRoute()"
    [showMenuToggle]="minMenuSize() > 0"
    *dxTemplate="let dataMenu of 'panel'"
    (selectedItemChanged)="navigationChanged($event)"
    (menuToggle)="menuOpened.set(!menuOpened())"
  />

  <dx-drawer
    class="detail-drawer"
    [opened]="isDetailOutletActive()"
    position="right"
    openedStateMode="shrink"
    revealMode="slide"
    [maxSize]="detailPanelWidth()"
    [closeOnOutsideClick]="false"
    (openedChange)="onDetailPanelClosed($event)"
  >
    <div
      *dxTemplate="let data of 'panel'"
      class="detail-panel"
      [style.width.px]="detailPanelWidth()"
    >
      <router-outlet name="detail" />
    </div>

    <dx-scroll-view class="with-footer">
      <div class="content">
        <ng-content />
      </div>

      <div class="content-block">
        <ng-content select="app-footer" />
      </div>
    </dx-scroll-view>
  </dx-drawer>
</dx-drawer>
